import { render } from "./Gemischtes.vue?vue&type=template&id=3768d196&scoped=true"
import script from "./Gemischtes.vue?vue&type=script&lang=js"
export * from "./Gemischtes.vue?vue&type=script&lang=js"

import "./Gemischtes.vue?vue&type=style&index=0&id=3768d196&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3768d196"]])

export default __exports__